import { AnimatePresence } from 'framer-motion';
import { useReferralHistoryContext } from '../../../contexts/ReferralHistoryProvider';
import ReferralDetailsModal from '../../CommonComps/Modals/ReferralDetailsModal';

const ReferralModalWrapper = () => {
  // integration of context hooks here
  const { showReferralDetailsModal, setShowReferralDetailsModal } =
    useReferralHistoryContext();

  // rendering referral modal wrapper section component here
  return (
    <section>
      <AnimatePresence initial={false} mode='wait' onExitComplete={() => null}>
        {showReferralDetailsModal ? (
          <ReferralDetailsModal
            handleModalClose={() => setShowReferralDetailsModal(false)}
          />
        ) : null}
      </AnimatePresence>
    </section>
  );
};

export default ReferralModalWrapper;
